import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LuCrown,
  LuX,
  LuCheck,
  LuInfo,
  LuCircleAlert,
  LuCreditCard,
  LuUserPlus,
  LuArrowUpRight,
} from 'react-icons/lu';
import { ReactComponent as ReservingTicket } from '../../assets/Illustrations/ReservingTicket.svg';
const isPWA = () =>
  window.matchMedia?.('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;
/**
 * TEMPORARY PREVIEW
 *
 * true  = show every footer state underneath each other
 * false = show the real footer state only
 */
const SHOW_ALL_STATES = false;
const PREVIEW_STATES = [
  {
    label: '1. Host',
    props: {
      hostAccess: true,
      hasAccount: true,
      membershipActive: true,
      membershipStatus: 'active',
      reservationAccessStatus: 'active',
      membershipUsed: 0,
      membershipLimit: 3,
    },
  },
  {
    label: '2. Spot reserved',
    props: {
      isRegistered: true,
      hasAccount: true,
      membershipActive: true,
      membershipStatus: 'active',
      reservationAccessStatus: 'active',
      membershipUsed: 1,
      membershipLimit: 3,
    },
  },
  {
    label: '3. Gathering sold out',
    props: {
      isSoldOut: true,
      hasAccount: true,
      membershipActive: true,
      membershipStatus: 'active',
      reservationAccessStatus: 'active',
      displayCapacity: 10,
      displayAttendeeCount: 10,
      membershipUsed: 0,
      membershipLimit: 3,
    },
  },
  {
    label: '4. Account required',
    props: {
      hasAccount: false,
      membershipActive: false,
      membershipStatus: 'inactive',
      reservationAccessStatus: '',
      membershipUsed: 0,
      membershipLimit: 3,
    },
  },
  {
    label: '5. Ready to reserve',
    props: {
      hasAccount: true,
      membershipActive: true,
      membershipStatus: 'active',
      reservationAccessStatus: 'active',
      membershipCardRequired: false,
      membershipUsed: 0,
      membershipLimit: 3,
    },
  },
  {
    label: '6. Reservation limit reached',
    props: {
      hasAccount: true,
      membershipActive: true,
      membershipStatus: 'active',
      reservationAccessStatus: 'limit_reached',
      membershipCardRequired: false,
      membershipUsed: 3,
      membershipLimit: 3,
    },
  },
  {
    label: '7. Card permanently required',
    props: {
      hasAccount: true,
      membershipActive: false,
      membershipStatus: 'card_required',
      reservationAccessStatus: 'card_required',
      membershipCardRequired: true,
      membershipUsed: 0,
      membershipLimit: 3,
    },
  },
  {
    label: '8. Required card has an issue',
    props: {
      hasAccount: true,
      membershipActive: false,
      membershipStatus: 'card_issue',
      reservationAccessStatus: 'card_issue',
      membershipCardRequired: true,
      membershipCardRequiresReplacement: true,
      membershipUsed: 0,
      membershipLimit: 3,
    },
  },
  {
    label: '9. Portal open - reserved',
    props: {
      portalOpen: true,
      isRegistered: true,
      hasAccount: true,
      membershipActive: true,
      membershipStatus: 'active',
      reservationAccessStatus: 'active',
      membershipUsed: 1,
      membershipLimit: 3,
    },
  },
  {
    label: '10. Gathering started - not registered',
    props: {
      portalOpen: true,
      eventStarted: true,
      hasAccount: true,
      membershipActive: true,
      membershipStatus: 'active',
      reservationAccessStatus: 'active',
      membershipUsed: 1,
      membershipLimit: 3,
    },
  },
];
const S = {
  previewPage: {
    width: '100%',
    padding: '18px 12px 40px',
    boxSizing: 'border-box',
    background: '#fff',
  },
  previewWrap: {
    width: '100%',
    maxWidth: 740,
    margin: '0 auto',
    display: 'grid',
    gap: 26,
  },
  previewState: {
    minWidth: 0,
  },
  previewLabel: {
    margin: '0 0 8px 3px',
    color: '#777',
    fontSize: 11,
    lineHeight: 1,
    fontWeight: 850,
    letterSpacing: '0.055em',
    textTransform: 'uppercase',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  actionBar: {
    position: 'fixed',
    left: '50%',
    bottom: 'calc(10px + env(safe-area-inset-bottom, 0px))',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 20px)',
    maxWidth: 740,
    zIndex: 50,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '11px 12px',
    boxSizing: 'border-box',
    background: 'rgba(255,255,255,0.96)',
    border: '1px solid rgba(15,23,42,0.08)',
    borderRadius: 12,
    boxShadow: '0 14px 38px rgba(15,23,42,0.14)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  
  joinActionBar: {
  padding: '16px 12px',
},

  previewActionBar: {
    position: 'relative',
    left: 'auto',
    bottom: 'auto',
    transform: 'none',
    width: '100%',
    maxWidth: 'none',
    zIndex: 1,
  },
  statusIcon: {
    width: 30,
    height: 30,
    borderRadius: 8,
    color: '#0b0b0b',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  statusIconDark: {
    color: '#000',
  },
  statusIconWarning: {
    color: '#000',
  },
  statusIconDanger: {
    color: '#B91C1C',
  },
  leftInfo: {
    flex: '1 1 0',
    minWidth: 0,
  },
  title: {
    fontSize: 13.5,
    fontWeight: 900,
    color: '#0b0b0b',
    lineHeight: 1.05,
    letterSpacing: '-0.035em',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  caption: {
    fontSize: 12,
    lineHeight: 1.18,
    fontWeight: 650,
    color: '#6b7280',
    marginTop: 5,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    marginTop: 8,
    color: '#111',
    fontSize: 11.5,
    lineHeight: 1,
    fontWeight: 850,
    letterSpacing: '-0.018em',
    whiteSpace: 'nowrap',
  },
  primaryBtn: {
    height: 42,
    borderRadius: 8,
    border: '1px solid #0b0b0b',
    background: '#0b0b0b',
    color: '#fff',
    fontSize: 12,
    fontWeight: 875,
    letterSpacing: '-0.015em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: '0 13px',
    flex: '0 0 auto',
    minWidth: 140,
    position: 'relative',
    overflow: 'hidden',
    transition:
      'background-color 220ms ease, border-color 220ms ease, transform 160ms ease, opacity 160ms ease',
  },
  joinButton: {
    border: '1px solid #fbe67a',
    background: '#fbe67a',
    color: '#171717',
    fontFamily: 'inherit',
    fontSize: 12,
    fontWeight: 875,
    letterSpacing: '-0.015em',
    gap: 9,
    lineHeight: 1.2,
    transition: 'background 160ms ease, border-color 160ms ease',
  },
  primaryBtnLoading: {
    cursor: 'wait',
  },
  primaryBtnSuccess: {
    background: '#166534',
    borderColor: '#166534',
  },
  primaryBtnContent: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    whiteSpace: 'nowrap',
    transition: 'opacity 180ms ease, transform 180ms ease',
  },
  spinner: {
    width: 14,
    height: 14,
    borderRadius: '50%',
    border: '2px solid rgba(255,255,255,0.35)',
    borderTopColor: '#fff',
    animation: 'spin 720ms linear infinite',
    flexShrink: 0,
  },
  checkIcon: {
    width: 16,
    height: 16,
    color: '#fff',
    strokeWidth: 3,
    animation: 'checkPop 260ms cubic-bezier(.2,1.35,.2,1)',
    flexShrink: 0,
  },
  disabled: {
    background: '#e5e7eb',
    borderColor: '#e5e7eb',
    color: '#9ca3af',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
  dangerBtn: {
    borderColor: '#b91c1c',
    background: '#b91c1c',
  },
  pausedBtn: {
    borderColor: '#0b0b0b',
    background: '#0b0b0b',
  },
  dimmed: {
    opacity: 0.62,
  },
  backdrop: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.40)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    padding: 8,
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  sheet: {
    width: '100%',
    maxWidth: 440,
    background: '#ffffff',
    borderRadius: 12,
    boxShadow: '0 8px 28px rgba(0,0,0,0.25)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    animation: 'slideUp .22s ease-out',
  },
  header: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 48,
    padding: '0 12px',
    borderBottom: '1px solid #eef0f2',
  },
  headerTitle: {
    fontSize: 14,
    fontWeight: 800,
    color: '#0b0b0b',
    letterSpacing: '-0.01em',
  },
  closeBtn: {
    position: 'absolute',
    right: 8,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'transparent',
    border: '1px solid #e5e7eb',
    width: 32,
    height: 32,
    borderRadius: 8,
    display: 'grid',
    placeItems: 'center',
    lineHeight: 0,
    color: '#0b0b0b',
    cursor: 'pointer',
    padding: 0,
  },
  body: {
    padding: '12px 12px 14px',
  },
  illustration: {
    height: 180,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 14,
  },
  reservingIllustration: {
    width: '100%',
    maxWidth: 200,
    height: 'auto',
    display: 'block',
    transform: 'rotate(-12deg)',
  },
  creditLead: {
    textAlign: 'center',
    marginBottom: 12,
  },
  creditAmount: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '7px 12px',
    borderRadius: 999,
    background: '#FFF0A8',
    color: '#0b0b0b',
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 900,
    letterSpacing: '-0.025em',
    marginBottom: 10,
  },
  sheetTitle: {
    margin: 0,
    fontSize: 22,
    lineHeight: 1.12,
    fontWeight: 950,
    color: '#0b0b0b',
    letterSpacing: '-0.045em',
  },
  sheetText: {
    margin: '7px auto 0',
    maxWidth: 330,
    fontSize: 14,
    lineHeight: 1.45,
    color: '#4b5563',
    fontWeight: 500,
  },
  remainingText: {
    margin: '10px auto 0',
    color: '#0b0b0b',
    fontSize: 13,
    lineHeight: 1.35,
    fontWeight: 750,
    letterSpacing: '-0.02em',
    textAlign: 'center',
  },
  footer: {
    padding: 12,
  },
  footerRow: {
    display: 'flex',
    gap: 8,
  },
  secondaryBtn: {
    flex: 1,
    height: 44,
    borderRadius: 10,
    border: '1px solid #e5e7eb',
    background: '#fff',
    color: '#0b0b0b',
    fontSize: 13,
    fontWeight: 800,
    cursor: 'pointer',
  },
  confirmBtn: {
    flex: 1,
    height: 44,
    borderRadius: 10,
    border: '1px solid #0b0b0b',
    background: '#0b0b0b',
    color: '#fff',
    fontSize: 13,
    fontWeight: 800,
    cursor: 'pointer',
  },
};
function ReserveConfirmBottomSheet({
  remaining,
  limit,
  onConfirm,
  onDismiss,
}) {
  const scrollYRef = useRef(0);
  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');
    scrollYRef.current =
      window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${scrollYRef.current}px`;
    document.body.classList.add('overlay-active');
    document.documentElement.classList.add('overlay-active');
    document.getElementById('root')?.classList.add('overlay-active');
    if (meta) {
      meta.content = '#999998';
    }
    return () => {
      const y = scrollYRef.current;
      document.body.classList.remove('overlay-active');
      document.documentElement.classList.remove('overlay-active');
      document.getElementById('root')?.classList.remove('overlay-active');
      document.body.style.top = '';
      window.scrollTo(0, y);
      const currentMeta = document.querySelector(
        'meta[name="theme-color"]'
      );
      if (currentMeta) {
        currentMeta.content = '#ffffff';
      }
    };
  }, []);
  return (
    <div style={S.backdrop} onClick={onDismiss}>
      <div
        style={{
          ...S.sheet,
          paddingBottom: `calc(12px + env(safe-area-inset-bottom,0px) + ${
            isPWA() ? 8 : 0
          }px)`,
        }}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Confirm reservation"
      >
        <div style={S.header}>
          <div style={S.headerTitle}>Confirm Reservation</div>
          <button
            type="button"
            aria-label="Close"
            style={S.closeBtn}
            onClick={onDismiss}
          >
            <LuX size={17} />
          </button>
        </div>
        <div style={S.body}>
          <div style={S.illustration} aria-hidden>
            <ReservingTicket style={S.reservingIllustration} />
          </div>
          <div style={S.creditLead}>
            <div style={S.creditAmount}>
              1 reservation will be used
            </div>
            <h2 style={S.sheetTitle}>Reserve your spot?</h2>
            <p style={S.sheetText}>
              We’ll hold this spot for you once you confirm.
            </p>
            <div style={S.remainingText}>
              You’ll have {Math.max(0, remaining - 1)}/{limit}{' '}
              reservations left after this.
            </div>
          </div>
        </div>
        <div style={S.footer}>
          <div style={S.footerRow}>
            <button
              type="button"
              style={S.secondaryBtn}
              onClick={onDismiss}
            >
              Not now
            </button>
            <button
              type="button"
              style={S.confirmBtn}
              onClick={onConfirm}
            >
              Reserve
            </button>
          </div>
        </div>
        <style>{`
          @keyframes slideUp {
            from {
              transform: translateY(16px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
          @media (prefers-reduced-motion: reduce) {
            * {
              animation: none !important;
              transition: none !important;
            }
          }
          button:focus-visible {
            outline: 0;
            box-shadow: 0 0 0 3px rgba(59,130,246,.45);
          }
        `}</style>
      </div>
    </div>
  );
}
export default function MembershipEventFooterAction({
  portalOpen = false,
  eventStarted = false,
  isRegistered = false,
  hostAccess = false,
  onEnter,
  onBeforeReserve,
  onRegister,
  onCancel,
  registerDisabled = false,
  registerLabel,
  autoOpenConfirm = false,
  hasAccount = true,
  membershipActive = false,
  membershipStatus = '',
  reservationAccessStatus = '',
  membershipCardRequired = false,
  membershipCardRequiresReplacement = false,
  attendanceWarning = false,
  reservationAttendanceStreak = 0,
  membershipUsed = 0,
  membershipLimit = 3,
  isSoldOut = false,
  displayCapacity,
  displayAttendeeCount,
  capacity,
  attendeeCount,
  embeddedPreview = false,
}) {
  const navigate = useNavigate();
  const [showConfirmSheet, setShowConfirmSheet] =
  React.useState(false);
const autoOpenedConfirmRef =
  React.useRef(false);
const [footerActionState, setFooterActionState] =
  React.useState('idle');
  const timersRef = React.useRef([]);
  const normalizedMembershipStatus = String(
    membershipStatus || ''
  ).toLowerCase();
  const normalizedAccessStatus = String(
    reservationAccessStatus || ''
  ).toLowerCase();
  const needsAccount = !hasAccount;
  // Portal access and registration cutoff are separate states.
  // Registered guests + hosts can enter starting 1 hour before the gathering.
  // Unregistered guests can still reserve until the actual start time.
  const canEnterPortal =
    portalOpen && (isRegistered || hostAccess);
  const registrationClosed =
    eventStarted && !isRegistered && !hostAccess;
  const isCardIssue =
    normalizedAccessStatus === 'card_issue' ||
    membershipCardRequiresReplacement === true ||
    ['card_issue', 'past_due', 'unpaid'].includes(
      normalizedMembershipStatus
    );
  const isCardRequired =
    normalizedAccessStatus === 'card_required' ||
    (
      membershipCardRequired &&
      !membershipActive &&
      !isCardIssue
    );
  const isAttendanceWarning =
    normalizedAccessStatus === 'warning' ||
    attendanceWarning === true;
  const reservationAccessPaused =
    isCardRequired || isCardIssue;
  const shownCapacity = Number(
    displayCapacity ?? capacity ?? 0
  );
  const shownCount = Number.isFinite(
    Number(displayAttendeeCount)
  )
    ? Number(displayAttendeeCount)
    : Number.isFinite(Number(attendeeCount))
    ? Number(attendeeCount)
    : 0;
  const isLimited = shownCapacity > 0;
  const isFull =
    Boolean(isSoldOut) ||
    (isLimited && shownCount >= shownCapacity);
  const used = Number(membershipUsed || 0);
  const limit = Number(membershipLimit || 3);
  const remaining = Math.max(0, limit - used);
  const reachedLimit =
    (
      normalizedAccessStatus === 'limit_reached' ||
      (
        membershipActive &&
        remaining <= 0
      )
    ) &&
    !isRegistered;
  const isRegisterAnimating =
    footerActionState === 'loading' ||
    footerActionState === 'success';
  const disabled =
    hostAccess ||
    registrationClosed ||
    registerDisabled ||
    isRegisterAnimating ||
    (
      !isRegistered &&
      (
        isFull ||
        reachedLimit
      )
    );
  const buttonLabel = registerDisabled
    ? registerLabel || 'Checking…'
    : hostAccess
    ? 'Hosting'
    : isRegistered
    ? 'Cancel'
    : isFull
    ? 'Sold Out'
    : reachedLimit
    ? 'Limit Reached'
    : needsAccount
    ? 'Get Started'
    : isCardIssue
    ? 'Update Card'
    : isCardRequired
    ? 'Add Card'
    : 'Reserve';
  const title = hostAccess
    ? 'You’re the host'
    : isRegistered
    ? 'Spot reserved'
    : isFull
    ? 'Gathering is full'
    : reachedLimit
    ? 'Reservation limit reached'
    : needsAccount
    ? 'Become a member'
    : isCardIssue
    ? 'Card update needed'
    : isCardRequired
    ? 'Reservation access paused'
    : 'Ready to reserve';
  const caption = hostAccess
    ? 'You’re hosting this gathering'
    : isRegistered
    ? 'You’re all set!'
    : isFull
    ? 'No spots available right now'
    : reachedLimit
    ? `You’ve used all ${limit} reservations`
    : needsAccount
    ? `${limit} reservations a month`
    : isCardIssue
    ? 'Update your card to reserve'
    : isCardRequired
    ? 'Add a card to reserve again'
    : `${remaining}/${limit} reservations left`;
  const pillText = isRegistered
    ? 'Reservation confirmed'
    : hostAccess
    ? 'Host assigned'
    : isFull
    ? 'Sold out'
    : reachedLimit
    ? 'Limit reached'
    : needsAccount
    ? 'Free membership'
    : isCardIssue || isCardRequired
    ? 'Action needed'
    : 'Access active';
  const iconState = isRegistered
    ? 'success'
    : isFull || isCardIssue || reachedLimit
    ? 'danger'
    : needsAccount
    ? 'join'
    : isCardRequired
    ? 'warning'
    : 'active';
  const shouldConfirmReservation =
    (membershipActive || isAttendanceWarning) &&
    !eventStarted &&
    !reservationAccessPaused &&
    !isRegistered &&
    !hostAccess &&
    !registerDisabled &&
    !isFull &&
    !reachedLimit;
    React.useEffect(() => {
  if (
    !autoOpenConfirm ||
    autoOpenedConfirmRef.current ||
    !shouldConfirmReservation
  ) {
    return;
  }
  autoOpenedConfirmRef.current = true;
  setShowConfirmSheet(true);
}, [
  autoOpenConfirm,
  shouldConfirmReservation,
]);
  React.useEffect(() => {
    return () => {
      timersRef.current.forEach((timer) => {
        clearTimeout(timer);
      });
      timersRef.current = [];
    };
  }, []);
  function makeSafeEvent() {
    return {
      stopPropagation: () => {},
      preventDefault: () => {},
    };
  }
  function runFooterRegisterAnimation(callback) {
    timersRef.current.forEach((timer) => {
      clearTimeout(timer);
    });
    timersRef.current = [];
    setFooterActionState('loading');
    const firstTimer = setTimeout(async () => {
      try {
        await Promise.resolve(callback?.());
      } catch (error) {
        console.error('[reserve register error]', error);
        setFooterActionState('idle');
        return;
      }
      setFooterActionState('success');
      const secondTimer = setTimeout(() => {
        setFooterActionState('idle');
      }, 900);
      timersRef.current.push(secondTimer);
    }, 650);
    timersRef.current.push(firstTimer);
  }
function handlePrimaryClick(event) {
  event?.stopPropagation?.();
  event?.preventDefault?.();
  if (disabled || hostAccess || registrationClosed) {
    return;
  }
  if (needsAccount) {
    navigate('/register');
    return;
  }
  if (isCardIssue) {
    navigate('/membership', {
      state: {
        intent: 'update_card',
      },
    });
    return;
  }
  if (isCardRequired) {
    navigate('/membership', {
      state: {
        intent: 'add_card',
      },
    });
    return;
  }
  if (isRegistered) {
    onCancel?.(event);
    return;
  }
  /*
   * HARD RULE:
   * The Reserve button must NEVER create a reservation directly.
   * Its only job is to open the confirmation sheet.
   *
   * This stays true even immediately after refresh while membership
   * data is still loading. The actual reservation API call can only
   * happen from handleConfirmReservation().
   */
  setShowConfirmSheet(true);
  return;
}
  async function handleConfirmReservation(event) {
    event?.stopPropagation?.();
    event?.preventDefault?.();
    setShowConfirmSheet(false);
    // Run eligibility / audience preflight only AFTER
    // the user confirms they want to reserve.
    const passedPreflight =
      await onBeforeReserve?.(makeSafeEvent());
    if (passedPreflight === false) {
      return;
    }
    runFooterRegisterAnimation(() =>
      onRegister?.(makeSafeEvent())
    );
  }
  function renderStatusIcon() {
    const baseStyle = {
      ...S.statusIcon,
      ...(
        iconState === 'active' ||
        iconState === 'success'
          ? S.statusIconDark
          : {}
      ),
      ...(
        iconState === 'warning' ||
        iconState === 'join'
          ? S.statusIconWarning
          : {}
      ),
      ...(
        iconState === 'danger'
          ? S.statusIconDanger
          : {}
      ),
    };
    if (iconState === 'success') {
      return (
        <div style={baseStyle}>
          <LuCheck size={16} strokeWidth={2.7} />
        </div>
      );
    }
    if (iconState === 'join') {
      return (
        <div style={baseStyle}>
          <LuUserPlus size={19} strokeWidth={2.2} />
        </div>
      );
    }
    if (isCardRequired) {
      return (
        <div style={baseStyle}>
          <LuCreditCard size={16} strokeWidth={2.5} />
        </div>
      );
    }
    if (
      iconState === 'warning' ||
      iconState === 'danger'
    ) {
      return (
        <div style={baseStyle}>
          <LuCircleAlert size={16} strokeWidth={2.5} />
        </div>
      );
    }
    return (
      <div style={baseStyle}>
        <LuCrown size={16} strokeWidth={2.5} />
      </div>
    );
  }
  function renderFooterButtonContent() {
    if (footerActionState === 'loading') {
      return (
        <span style={S.primaryBtnContent}>
          <span style={S.spinner} aria-hidden />
          Reserving
        </span>
      );
    }
    if (footerActionState === 'success') {
      return (
        <span style={S.primaryBtnContent}>
          <LuCheck size={14} style={S.checkIcon} />
          Reserved
        </span>
      );
    }
    return (
      <span style={S.primaryBtnContent}>
        {buttonLabel}
      </span>
    );
  }
  if (SHOW_ALL_STATES && !embeddedPreview) {
    return (
      <div style={S.previewPage}>
        <div style={S.previewWrap}>
          {PREVIEW_STATES.map((preview) => (
            <div
              key={preview.label}
              style={S.previewState}
            >
              <div style={S.previewLabel}>
                {preview.label}
              </div>
              <MembershipEventFooterAction
                {...preview.props}
                embeddedPreview
                onEnter={() => {}}
                onRegister={() => {}}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
  return (
    <>
      <footer
        style={{
          ...S.actionBar,
          ...(needsAccount ? S.joinActionBar : {}),
          ...(embeddedPreview
            ? S.previewActionBar
            : {}),
        }}
      >
        {canEnterPortal ? (
          <button
            type="button"
            style={{
              ...S.primaryBtn,
              flex: 1,
            }}
            onClick={onEnter}
          >
            Enter Portal
          </button>
        ) : registrationClosed ? (
          <button
            type="button"
            disabled
            aria-disabled="true"
            style={{
              ...S.primaryBtn,
              ...S.disabled,
              flex: 1,
            }}
          >
            Registration Closed
          </button>
        ) : (
          <>
            {renderStatusIcon()}
            <div
              style={{
                ...S.leftInfo,
                ...(disabled
                  ? S.dimmed
                  : {}),
              }}
            >
              <div style={S.title}>
                {title}
              </div>
              <div
                style={{
                  ...S.caption,
                  ...(needsAccount
                    ? {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5,
                      }
                    : {}),
                }}
              >
                {needsAccount ? (
                  <>
                    Free to join · Invite-only
                  </>
                ) : (
                  caption
                )}
              </div>
              {!needsAccount && (
                <span style={S.pill}>
                  {iconState === 'active' ||
                  iconState === 'success' ? (
                    <LuInfo
                      size={12.5}
                      strokeWidth={2.8}
                    />
                  ) : (
                    <LuCircleAlert
                      size={12.5}
                      strokeWidth={2.6}
                    />
                  )}
                  {pillText}
                </span>
              )}
            </div>
            <button
              type="button"
              onClick={handlePrimaryClick}
              disabled={disabled}
              className={needsAccount ? 'membershipJoinButton' : undefined}
              style={{
                ...S.primaryBtn,
                ...(needsAccount ? S.joinButton : {}),
                ...(footerActionState === 'loading'
                  ? S.primaryBtnLoading
                  : {}),
                ...(footerActionState === 'success'
                  ? S.primaryBtnSuccess
                  : {}),
                ...(reservationAccessPaused &&
                footerActionState === 'idle'
                  ? S.pausedBtn
                  : {}),
                ...(isRegistered &&
                !hostAccess &&
                footerActionState === 'idle'
                  ? S.dangerBtn
                  : {}),
                ...(disabled &&
                footerActionState === 'idle'
                  ? S.disabled
                  : {}),
              }}
            >
              {renderFooterButtonContent()}
              {needsAccount && footerActionState === 'idle' && (
                <LuArrowUpRight size={16} aria-hidden="true" />
              )}
            </button>
          </>
        )}
      </footer>
      {showConfirmSheet && (
        <ReserveConfirmBottomSheet
          remaining={remaining}
          limit={limit}
          onDismiss={() => {
            setShowConfirmSheet(false);
          }}
          onConfirm={handleConfirmReservation}
        />
      )}
      <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes checkPop {
          from {
            transform: scale(0.65);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .membershipJoinButton:hover:not(:disabled) {
          background: #f5dc59 !important;
          border-color: #f5dc59 !important;
        }
        @media (max-width: 360px) {
          footer[style] {
            gap: 8px !important;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          * {
            animation: none !important;
            transition: none !important;
          }
        }
      `}</style>
    </>
  );
}
